import GetLabel from "foundation/js/getLabel"
import { computed, onMounted, ref } from "vue"
import FormInputTextField from 'components/FormInputTextField/FormInputTextField.vue'
import FormAddressField from 'components/FormAddressField/FormAddressField.vue'
import phoneValidator from '../../foundation/js/inputValidators/phoneValidator'
import { useStore } from "vuex"

export default {
    name: "FrivilligeCheckoutStepOne",
    components: {
        FormInputTextField, 
        FormAddressField
    },
    setup() {
        const store = useStore()
        const userInformation = computed(() => store.state.checkout.purchaseData.invoice.userInformation)
        const invoiceAddress = computed(() => store.state.checkout.purchaseData.invoice.invoiceAddress)

        const displayErrorMessages = ref(false)
        
        const disablePhoneInput = !!userInformation.value.mobilePhone
        const phoneInput = ref(userInformation.value?.mobilePhone || '')
        const phoneInputFilled = computed (() =>  phoneValidator(phoneInput.value) )

        const onSubmit = () => {
            displayErrorMessages.value = true
            if (!phoneInputFilled.value) {
                return
            }

            const updatedUserInformation = {
                ...userInformation.value,
                mobilePhone: phoneInput.value,
            }

            store.commit('checkout/set_active_delivery_address', invoiceAddress.value)
            store.commit('checkout/set_purchase_data_invoice', {
                userInformation: updatedUserInformation,
                invoiceAddress: invoiceAddress.value
            })

            // if succes set been filled to current step, as data is now in session storage
            store.commit('checkout/update_checkout_step_been_filled', 1)
            // if succes set step to next stepNumber
            store.commit('checkout/update_checkout_step',{nextStepNumber: 2})
        }
        
        return {
            userInformation,
            phoneInput,
            phoneInputFilled,
            disablePhoneInput,
            displayErrorMessages,
            invoiceAddress,
            onSubmit,
            getLabel: (labelKey) => GetLabel({ labelKey, labelCollection: "checkout" })
        }
    }
}